export default {
  title: 'Sumă minimă de plată: Plățile nu pot fi între {{rangeStart}} - {{rangeEnd}}',
  description: 'Excepție: Dacă ai un articol gratuit, poți finaliza comanda cu un total de {{amount}}.',
};
